import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80be0392"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "입력하기", -1))
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "초대 코드 입력", -1))
const _hoisted_8 = {
  key: 0,
  class: "input_box"
}
const _hoisted_9 = {
  key: 1,
  class: "input_box"
}
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "할인 코드 입력", -1))
const _hoisted_12 = { class: "input_box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "확인")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.registInviteCode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_ion_label, { class: "regist_code" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.registInviteCode), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_ion_input, {
                modelValue: _ctx.inviteCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inviteCode) = $event)),
                type: "text",
                onKeyUp: _withKeys(_ctx.sendPost, ["enter"])
              }, null, 8, ["modelValue", "onKeyUp"]),
              _createElementVNode("div", {
                style: _normalizeStyle(_ctx.inviteCode == '' ? { opacity: 0.3 } : ''),
                class: "input_btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendPost && _ctx.sendPost(...args)))
              }, " 입력 ", 4)
            ]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ion_input, {
            modelValue: _ctx.discountCode,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.discountCode) = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            style: _normalizeStyle(_ctx.discountCode == '' ? { opacity: 0.3 } : ''),
            class: "input_btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.postSend && _ctx.postSend(...args)))
          }, " 입력 ", 4)
        ])
      ])
    ])
  ]))
}